export default __webpack_public_path__ + "static/media/caq_march_break_poster_2026.cc032097.jpg";